module.exports = __webpack_public_path__ + "img/fl_big2.3edb0046.png";